import { PropTypes } from "prop-types";
import Editor from "@monaco-editor/react";

export const CodeEditor = ({
  height,
  defaultLanguage = "json",
  defaultValue = "",
  editorOptions,
  onChange,
  onMount,
  onValidate,
  willMount,
  theme,
  readOnlyTooltipMessage = "Can't edit in readonly mode.",
  value,
  className,
  wrapperProps,
}) => {
  const handleEditorWillMount = function (monaco) {
    monaco.editor.defineTheme("nemo-readonly", {
      base: "vs",
      inherit: true,
      rules: [
        {
          token: "string.key.json",
          foreground: "4e45ad",
        },
        {
          token: "string.value.json",
          foreground: "499180",
        },
        {
          token: "number.json",
          foreground: "D91C5C",
        },
        {
          token: "keyword.json",
          foreground: "ed964f",
        },
      ],
      colors: {
        "editor.background": "#f5f5f5",
        "input.border": "#EBFDFA",
        "editorLineNumber.foreground": "#c5c5c5",
        "editorLineNumber.activeForeground": "#535353",
        "editorGutter.background": "#FFFFFF",
      },
    });
    monaco.editor.defineTheme("nemo", {
      base: "vs",
      inherit: true,
      rules: [
        { background: "#EBFDFA" },
        {
          token: "string.key.json",
          foreground: "4e45ad",
        },
        {
          token: "string.value.json",
          foreground: "499180",
        },
        {
          token: "number.json",
          foreground: "D91C5C",
        },
        {
          token: "keyword.json",
          foreground: "ed964f",
        },
      ],
      colors: {
        "input.border": "#EBFDFA",
        "editorLineNumber.foreground": "#c5c5c5",
        "editorLineNumber.activeForeground": "#535353",
      },
    });
    if (willMount) {
      willMount(monaco);
    }
  };

  const handleEditorOnMount = function (editor, monaco) {
    // Custom readonly message
    const messageContribution = editor.getContribution("editor.contrib.messageController");
    editor.onDidAttemptReadOnlyEdit(() => {
      messageContribution.showMessage(readOnlyTooltipMessage, editor.getPosition());
    });
    if (onMount) {
      onMount(editor, monaco);
    }
  };

  const handleEditorOnChange = function (value) {
    if (onChange) {
      onChange(value);
    }
  };

  const activeTheme = theme ?? (editorOptions?.readOnly ? "nemo-readonly" : "nemo");

  return (
    <Editor
      height={height}
      defaultLanguage={defaultLanguage}
      theme={activeTheme}
      options={{
        minimap: {
          enabled: false,
        },
        scrollbar: {
          vertical: "auto",
        },
        overviewRulerLanes: 0,
        hideCursorInOverviewRuler: true,
        overviewRulerBorder: false,
        scrollBeyondLastLine: false,
        ...editorOptions,
      }}
      defaultValue={defaultValue}
      value={value}
      beforeMount={handleEditorWillMount}
      onMount={handleEditorOnMount}
      onChange={handleEditorOnChange}
      onValidate={onValidate}
      className={className}
      wrapperProps={wrapperProps}
    />
  );
};
CodeEditor.propTypes = {
  className: PropTypes.string,
  defaultLanguage: PropTypes.string,
  editorOptions: PropTypes.object,
  height: PropTypes.number,
  onChange: PropTypes.func,
  onMount: PropTypes.func,
  readOnlyTooltipMessage: PropTypes.string,
  theme: PropTypes.string,
  value: PropTypes.string,
  willMount: PropTypes.func,
  wrapperProps: PropTypes.object,
};
